import { ErrorBaseData } from '.'

export const birdIdErrors: Record<string, ErrorBaseData> = {
  BirdIdTokenNotFoundException: {
    message: 'Token não encontrado',
    description: 'Não foi possível encontrar o token do BirdId para este médico',
  },
  BirdIdTokenHasExpiredException: {
    message: 'Token expirado',
    description: 'O token do BirdId está expirado. Autentique-se e tente novamente',
  },
  ///
  CouldNotSignDocumentException: {
    message: 'Erro ao assinar o documento',
    description: 'Não foi possível realizar a assinatura do documento. Tente novamente',
  },
  DocumentNotFoundException: {
    message: 'Documento não encontrado',
    description: 'Não foi possível encontrar o documento. Verifique as informações e tente novamente',
  },
  InvalidOtpException: {
    message: 'OTP inválido',
    description: 'O código OTP está invalido. Verifique o código e tente novamente',
  },
}
